import * as Styled from './Heading.styled';
import type { HeadingLevel, HeadingProps } from './types';

const getHeading = (level: HeadingLevel) => {
  if (level === 3) {
    return Styled.H3;
  }

  if (level === 2) {
    return Styled.H2;
  }

  return Styled.H1;
};

export const Heading = ({
  children,
  level,
  styledAs,
  ...deferred
}: HeadingProps) => {
  const Tag = getHeading(level);

  return (
    <Tag $styledAs={styledAs} {...deferred}>
      {children}
    </Tag>
  );
};
